import React, { Component, Fragment } from 'react';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { Row, Col, Spinner } from 'react-bootstrap';
import Alerts from '../../components/alerts';
import ConfirmationModal from '../../components/modalConfirmation';
import service from '../../services/statusService';

class Status extends Component {
	constructor(props) {
		super(props)
	
		this.state = {
			isLoading: true,
			isOffline: true,
			isModalDisplayed: false,
			alerts: [],
		}
	}

	async componentWillMount() {
		try {
			const res = await service.getOnlineStatus();
			if (res.isOffline != null) {
				this.setState({
					isLoading: false,
					isOffline: res.isOffline,
				});
			}
		} catch (e) {
			this.setState({
				alerts: [{type:'danger', msg:'Problem contacting service.'}],
			});
		}
	}

	handleModalClose = (isConfirmClicked) => {
		this.setState({isModalDisplayed: false});

		if (isConfirmClicked) {
			this.updateStatus(this.state.isOffline);
		} else {
			this.setState({
				isLoading: false,
				isOffline: !this.state.isOffline,
			});
		}
	}

	toggleStatus = (checked) => {
		const isOffline = !checked;
		this.setState({
			isModalDisplayed: true,
			isOffline: isOffline,
		});

		// for better ux, we wait for switch animation,
		// then we show the progress indicator and process request
		setTimeout(() => {
			this.setState({
				isLoading: true,
				alerts: [],
			});
		}, 500);
	}

	updateStatus = async (isOffline) => {
		try {
			const res = await service.setOnlineStatus(isOffline);
			if (res.isOffline != null) {
				this.setState({
					isOffline: res.isOffline,
					isLoading: false,
				});
			}
		} catch(e) {
			this.setState({
				alerts: [{type:'danger', msg:'Problem updating application status. Please try again.'}],
				isOffline: !isOffline,
				isLoading: false,
			});
		}
	}

	render() {
		return (
			<Fragment>
				<Row className="search-bar">
					<Col md={{span: 6, offset: 1}} sm={12}>
						<h3>Application Status :</h3>
					</Col>
					<Col md={{span: 3}} sm={12}>
						<div className="center-content">
							{
								this.state.isLoading
									? <Spinner id="spinner" animation="border" variant="primary" />
									: <BootstrapSwitchButton 
											id="statusSwitch"
											checked={!this.state.isOffline} 
											onstyle="outline-success" 
											offstyle="outline-danger" 
											onlabel="Online"
											offlabel="Offline"
											width={100}
											onChange={this.toggleStatus}/>
							}
						</div>
					</Col>
				</Row>
				<Alerts alerts={this.state.alerts} />
				<ConfirmationModal
					isDisplayed={this.state.isModalDisplayed}
					handleModalClose={this.handleModalClose}
					message={'Are you sure you want to set it ' + (this.state.isOffline ? 'Offline' : 'Online') + '?'}
					confirmButton="Go for it!" />
			</Fragment>
		)
	}
}

export default Status;